module.exports = __webpack_public_path__ + "img/imagen4.97ddc3a3.png";